import React from "react";
import { useMutation } from "@tanstack/react-query";
import { authEndpoints } from "@src/services/endpoints";
import { useAuthContext } from "@src/context/authContext";
import { useAdminContext } from "@src/context/adminContext";
import AdminHooks from "@src/context/hooks/adminHooks";
import { Button, Divider, CustomerDropDown } from "@src/components/atoms";
import { ImpersonateLoginForm } from "@src/components/forms/admin";
import { CardContainer } from "../../components/cards";

export const DashboardPage = () => {
  const { selectedCustomer } = useAdminContext();
  const auth = useAuthContext();

  const impersonateLogin = useMutation({
    mutationKey: ["IMPERSONATE_LOGIN"],
    mutationFn: (req) => authEndpoints.impersonateLogin(req),
    onSuccess: (res, variables) => {
      auth.setImpersonatedSession(variables);
      auth.setUserTokens(res.data);
      window.location.href = "/dashboard"; // force reload
    },
  });

  return (
    <section className="m-6">
      <div className="mb-4 text-center">
        <h2 className=" text-center">Admin Dashboard/Overview</h2>
        <p className="text-center">
          Welcome, {auth?.user?.firstname || "Admin"}!
        </p>
      </div>
      <CardContainer padding={8}>
        <div className="flex flex-col gap-4">
          <CustomerDropDown />
          <ImpersonateLoginForm
            impersonateIdentityProfile={impersonateLogin.mutateAsync}
            customerCode={selectedCustomer?.customerCode}
            error={impersonateLogin.error?.message}
          />
        </div>
      </CardContainer>
    </section>
  );
};
